import { HTMLProps, useState } from 'react'
import { TailSpin } from '../loaders'
import { styled } from '@linaria/react'

import { useBoundStore } from '../../store/store'
import Icon from '../icon'
import classNames from '../../utils/classNames'

const Container = styled.div`
  background-color: var(--tertiary);
  border-radius: 5px;
  display: flex;
  align-items: center;
  height: 50px;
  position: relative;
  padding: 0 16px;
  input {
    color: var(--txt);
    font-family: 'Avenir-Light';
    font-size: 15px;
    flex: 1;
    margin-right: 12px;
  }
  &.referral {
    background-color: var(--primary);
  }
  .password-icon {
    fill: var(--txt);
  }
  @media (min-width: 1200px) {
    input {
      font-size: 17px;
    }
  }
`

const Suffix = styled.p`
  margin-right: 8px;
  color: #888;
  font-family: 'Avenir-Light';
  font-size: 15px;
  @media (min-width: 1200px) {
    font-size: 17px;
  }
`

const ErrorMessage = styled.p`
  font-family: 'Avenir-Light';
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 10px;
  color: rgb(255, 64, 88);
`

interface TextInputProps extends HTMLProps<HTMLInputElement> {
  suffix?: string
  isPassword?: boolean
  isValid?: boolean
  isReferral?: boolean
  isValidating?: boolean
  error?: string
  containerClassName?: string
}

const TextInput = ({
  suffix,
  isPassword,
  isValid,
  isReferral,
  isValidating,
  error,
  containerClassName,
  ...rest
}: TextInputProps) => {
  const theme = useBoundStore(state => state.common.theme)
  const [hide, setHide] = useState(true)

  return (
    <>
      <Container
        className={classNames(isReferral ? 'referral' : '', containerClassName)}
        style={{ marginBottom: error ? 9 : 14 }}>
        {suffix && <Suffix>{suffix}</Suffix>}
        <input
          type={isPassword ? (hide ? 'password' : 'text') : undefined}
          {...rest}
        />
        {isValidating ? (
          <TailSpin
            color={theme === 'dark' ? '#fff' : '#0E091E'}
            width={18}
            height={18}
          />
        ) : (
          isValid && <Icon id="check-circle" width="18" height="18" />
        )}
        {isPassword && (
          <button
            type="button"
            className="flx-ctr"
            onClick={() => setHide(prev => !prev)}>
            {hide ? (
              <Icon
                id="eye-slash-2"
                width="18"
                height="17"
                fill="#fff"
                className="password-icon"
              />
            ) : (
              <Icon
                id="eye-2"
                width="18"
                height="13"
                fill="white"
                className="password-icon"
              />
            )}
          </button>
        )}
      </Container>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  )
}

export default TextInput
